const $ = jQuery.noConflict();

class TruncatedText {
	constructor() {
		this.textboxesOpen = $('.block-truncated-text__button--open');
		this.textboxesClose = $('.block-truncated-text__button--close');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.textboxesOpen.on('click', this.openTruncatedText);
		this.textboxesClose.on('click', this.closeTruncatedText);
	}
	openTruncatedText() {
		const textbox = $(this).closest('.block-truncated-text');
		textbox.addClass('block-truncated-text--open');
	}
	closeTruncatedText() {
		const textbox = $(this).closest('.block-truncated-text');
		textbox.removeClass('block-truncated-text--open');
	}
}

const newTruncatedText = new TruncatedText();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newTruncatedText.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
